import React, { useState, useEffect } from 'react'

interface CountdownTimerProps {
  initialMinutes: number
  onExpire?: () => void
}

export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  initialMinutes,
  onExpire,
}) => {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60)

  useEffect(() => {
    if (timeLeft <= 0) {
      onExpire?.()
      return
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          onExpire?.()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [timeLeft, onExpire])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return (
    <div
      className="px-6 py-4 rounded-lg text-center font-bold text-lg"
      style={{ backgroundColor: '#145F6B', color: 'white' }}
    >
      This Founding Member Offer Expires In:{' '}
      <span className="text-2xl">
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </span>
    </div>
  )
}

